import { useId } from 'react';

/**
 * Google Cloud Pub/Sub icon
 * @see https://cloud.google.com/icons
 */
export function GCPPubSubLightIcon() {
  const mask_id = useId();

  return (
    <svg height="16" width="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <mask
          id={mask_id}
          x="4.64"
          y="4.19"
          width="14.73"
          height="12.76"
          maskUnits="userSpaceOnUse">
          <circle cx="12" cy="12.23" r="3.58" fill="#fff" />
        </mask>
      </defs>
      <circle cx="18.97" cy="8.21" r="1.72" fill="#669df6" />
      <circle cx="5.03" cy="8.21" r="1.72" fill="#669df6" />
      <circle cx="12" cy="20.28" r="1.72" fill="#669df6" />
      <g mask={`url(#${mask_id})`}>
        <rect
          x="14.69"
          y="10.22"
          width="1.59"
          height="8.04"
          transform="matrix(0.5, -0.87, 0.87, 0.5, -4.59, 20.53)"
          fill="#4285f4"
        />
        <rect
          x="4.49"
          y="13.45"
          width="8.04"
          height="1.59"
          transform="translate(-5.98 6.17) rotate(-30)"
          fill="#4285f4"
        />
        <rect x="11.2" y="4.19" width="1.59" height="8.04" fill="#4285f4" />
      </g>
      <circle cx="12" cy="12.23" r="2.78" fill="#aecbfa" />
      <circle cx="5.03" cy="16.25" r="2.19" fill="#aecbfa" />
      <circle cx="18.97" cy="16.25" r="2.19" fill="#aecbfa" />
      <circle cx="12" cy="4.19" r="2.19" fill="#aecbfa" />
    </svg>
  );
}
